import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { ProgramService } from "../program.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Message } from "primeng/primeng";
import { MessageService } from "primeng/components/common/messageservice";
import { Subscription } from "rxjs/Subscription";
import { RequestService } from "../../requests/request.service";


import {
    ProgramPublicProfile,
    ProgramPublicProfileInformation,
    ProgramTimings,
    ProgramGradesServed,
    ProgramProgramsOffered,
    ProgramMealsServed,
    Program
} from "@models/program";
import { AreaMapRequest } from "@models/map";
import { DeleteRequest } from "@models/requests";

declare var jQuery: any;
declare var grecaptcha: any;

@Component({
    templateUrl: "./public-profile.component.html"
})

export class PublicProfileComponent implements OnInit {
    public id: number;
    public program: ProgramPublicProfile;
    public filters: AreaMapRequest;
    public captcha: any;
    public model: DeleteRequest;
    public invalid: boolean = true;
    public loading: boolean = false;

    public communitySchoolsTooltip: string = Program.communitySchoolsTooltip;

    @ViewChild("rm") rm;

    constructor(private programService: ProgramService,
        private requestService: RequestService,
        private route: ActivatedRoute,
        private router: Router,
        private title: Title,
        private msgService: MessageService) { }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.id = +params["id"];
            this.loading = true;
            this.program = undefined;
            this.programService.getProgramPublicProfile(this.id).finally(() => this.loading = false).subscribe(
                response => this.program = response
            );
        });

        let filters = localStorage.getItem("map-filters");
        if (filters != undefined) {
            localStorage.removeItem("map-filters");
            this.filters = <AreaMapRequest>JSON.parse(filters);
        }
    }

    openModal(): void {
        this.model = new DeleteRequest();
        this.model.programId = this.id;
        this.invalid = true;
        this.addShownListener();
        jQuery(this.rm.nativeElement).modal("show");
    }

    addShownListener(): void {
        jQuery(this.rm.nativeElement).on("shown.bs.modal", () => {
            this.renderCaptcha();
            this.removeShownListener();
        });
    }

    renderCaptcha(): void {
        let successCallback = (response) => {
            this.captchaSuccess(response);
        };

        let expiredCallback = () => {
            this.captchaExpired();
        };

        if (this.captcha == undefined) {
            this.captcha = grecaptcha.render("cap", {
                "sitekey": "6LcJ7DUUAAAAALwM0aEWvcu0bcnFiDxVqZ1GBeAI",
                "callback": successCallback,
                "expired-callback": expiredCallback
            });
        } else {
            grecaptcha.reset(this.captcha);
        }
    }

    captchaSuccess(data: any): void {
        if (this.model != undefined) {
            this.model.captchaCode = data;
            this.modelChange();
        }
    }

    captchaExpired(): void {
        if (this.model != undefined) {
            this.model.captchaCode = undefined;
            this.renderCaptcha();
        }
    }

    removeShownListener(): void {
        jQuery(this.rm.nativeElement).off("shown.bs.modal");
    }

    closeModal(): void {
        jQuery(this.rm.nativeElement).modal("hide");
    }

    backToMap(): void {
        if (this.filters != undefined) {
            let json = JSON.stringify(this.filters);
            localStorage.setItem("map-filters", json);
        }

        this.router.navigate(["map"]);
    }

    modelChange(): void {
        if (this.model == undefined) {
            this.invalid = true;
            return;
        }

        let reasonInvalid = this.model.reason == undefined;
        let nameInvalid = this.model.name == undefined;
        let phoneInvalid = this.model.phone == undefined;
        let emailInvalid = this.model.email == undefined;
        let captchaInvalid = this.model.captchaCode == undefined;

        if (!reasonInvalid && !nameInvalid && !phoneInvalid && !emailInvalid && !captchaInvalid) {
            this.invalid = false;
        } else {
            this.invalid = true;
        }
    }

    submitRequest(): void {
        this.loading = true;
        this.requestService.submitProgramDeleteRequest(this.model).finally(() => this.loading = false).subscribe(
            response => {
                this.closeModal();
                this.msgService.add({ severity: "success", summary: "Success", detail: response.message });
            },
            error => {
                this.msgService.add({ severity: "danger", summary: "Error", detail: error.message });
            }
        );
    }

    edit(): void {
        let link = "request-edit/" + this.id;
        this.router.navigate([link]);
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/programs/public-profile/public-profile.component.ts